/* BR BW - black and white redesign behaviour, 17 Sep 2026.
   1. Product page (snippets/br-pdp.liquid): gallery, options copied onto the real form,
      Add to cart taps the real submit button, description split into accordions.
   2. Product cards: photos swipe inside the card, round + adds to cart
      (a small picker opens first when the piece has sizes or other choices).
   Loaded from layout/theme.liquid. Delete the script tag there to switch it all off;
   the product page then still has the theme's own form, which assets/br-bw.css keeps
   off screen, so also remove the BR PDP block in br-bw.css if reverting. */
(function () {
  'use strict';
  var d = document;

  function money(txt) { return (txt || '').replace(/\s+/g, ' ').replace(/\.00(?!\d)/g, '').trim(); }
  function toast(msg, link) {
    var t = d.getElementById('br-toast');
    if (!t) { t = d.createElement('div'); t.id = 'br-toast'; t.setAttribute('role', 'status'); d.body.appendChild(t); }
    t.innerHTML = '<span></span>' + (link ? '<a href="/cart">View bag</a>' : '');
    t.firstChild.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
  }
  function refreshCount() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      d.querySelectorAll('[data-cart-count], .cart-count, .site-header__cart-count, .cart-link__count').forEach(function (n) { n.textContent = c.item_count; });
      d.dispatchEvent(new CustomEvent('br:cart', { detail: c }));
    }).catch(function () {});
  }
  function addVariant(id, btn) {
    if (btn) { btn.classList.add('is-pressed'); btn.setAttribute('aria-busy', 'true'); }
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { toast('Added to bag', true); refreshCount(); })
      .catch(function (e) { if (btn) btn.classList.remove('is-pressed'); toast((e && e.description) || 'Could not add this piece'); })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }

  /* ---------------- 1. PRODUCT PAGE ---------------- */
  function initPdp() {
    var root = d.getElementById('br-pdp');
    if (!root) return;
    d.body.classList.add('br-pdp-on');
    var form = d.querySelector('.adtocartmobile form.product-form') || d.querySelector('form.product-form');
    var real = form && form.querySelector('button[data-cart-submit]');
    var atc = d.getElementById('br-pdp-atc');
    var priceOut = d.getElementById('br-pdp-price');
    var priceNode = d.querySelector('.add-to-cart-placed .product__current-price') || d.querySelector('.product__current-price');
    var variants = [];
    try { variants = JSON.parse(d.getElementById('br-pdp-variants').textContent); } catch (e) {}

    /* header height, so the phone photo fills exactly the rest of the screen */
    function setTop() {
      var h = d.querySelector('.site-header') || d.querySelector('header');
      var top = h ? Math.max(0, h.getBoundingClientRect().bottom + window.pageYOffset) : 120;
      d.documentElement.style.setProperty('--br-hdr', Math.round(top) + 'px');
    }
    setTop(); window.addEventListener('load', setTop); window.addEventListener('resize', setTop);

    /* gallery */
    var track = d.getElementById('br-pdp-track');
    var slides = track ? track.children : [];
    var thumbs = root.querySelectorAll('.br-pdp__thumb');
    var lines = root.querySelectorAll('.br-pdp__lines b');
    function mark(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      lines.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
    }
    function go(i, smooth) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      mark(i);
    }
    if (track) {
      var tmr;
      track.addEventListener('scroll', function () {
        clearTimeout(tmr);
        tmr = setTimeout(function () { mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); }, 60);
      }, { passive: true });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(Number(t.getAttribute('data-i'))); }); });

    /* options -> real selects */
    function selects() { return form ? form.querySelectorAll('select[data-option-input]') : []; }
    function currentVariant() {
      var chosen = [];
      selects().forEach(function (s) { chosen.push(s.value); });
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var k = 0; k < chosen.length; k++) { if (v.options[k] !== chosen[k]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function sync() {
      if (priceNode && priceOut) { var p = money(priceNode.textContent); if (p) priceOut.textContent = p; }
      var v = currentVariant();
      if (atc) {
        var sold = (real && real.disabled) || (v && !v.available);
        atc.disabled = !!sold;
        atc.textContent = sold ? 'Sold out' : 'Add to cart';
      }
      return v;
    }
    root.querySelectorAll('[data-br-option]').forEach(function (group) {
      var name = group.getAttribute('data-br-option');
      group.querySelectorAll('button[data-value]').forEach(function (b) {
        b.addEventListener('click', function () {
          var val = b.getAttribute('data-value');
          selects().forEach(function (s) {
            if (s.name === name || s.id === name) { s.value = val; s.dispatchEvent(new Event('change', { bubbles: true })); }
          });
          group.querySelectorAll('button[data-value]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
          if (atc) atc.classList.remove('is-pressed');
          setTimeout(function () {
            var v = sync();
            if (v && v.featured_media && track) {
              for (var i = 0; i < slides.length; i++) { if (String(slides[i].getAttribute('data-media-id')) === String(v.featured_media.id)) { go(i); break; } }
            }
          }, 90);
        });
      });
    });
    if (priceNode && window.MutationObserver) new MutationObserver(sync).observe(priceNode.parentNode || priceNode, { childList: true, subtree: true, characterData: true });
    sync();

    if (atc) atc.addEventListener('click', function () {
      if (atc.disabled) return;
      atc.classList.add('is-pressed');
      if (real) { real.click(); }
      else { var v = currentVariant(); if (v) addVariant(v.id, atc); }
    });

    /* Try & Buy buttons move into the panel */
    var tb = d.querySelector('.adtocartmobile .three_btn_below_addtocart');
    var tbHome = d.getElementById('br-pdp-trybuy');
    if (tb && tbHome && tb.querySelector('a')) { tbHome.appendChild(tb); tbHome.classList.add('is-on'); }

    /* description -> accordions */
    var acc = d.getElementById('br-pdp-acc');
    if (acc) {
      var det = acc.querySelector('[data-k="details"] .br-acc__b');
      var box = { details: [], material: [], dims: [], care: [] };
      var mode = 'details';
      var nodes = Array.prototype.slice.call(det.children);
      nodes.forEach(function (n) {
        var t = (n.textContent || '').replace(/ /g, ' ').trim().toLowerCase();
        if (!t && !n.querySelector('img')) return;
        var head = t.replace(/[*:.\s]+$/, '');
        if (/^specifications?$/.test(head)) { mode = 'material'; n.remove(); return; }
        if (/^(dimensions?|size and fit|fit)$/.test(head)) { mode = 'dims'; n.remove(); return; }
        if (/^(material and fit info|material and fit|material|materials)$/.test(head)) { mode = 'material'; n.remove(); return; }
        if (/^care$/.test(head)) { mode = 'care'; n.remove(); return; }
        var target = mode;
        if (/^(length|width|height|weight|diameter|size|drop|inner diameter)\b[^a-z]{0,4}/.test(t)) target = 'dims';
        else if (/^(base material|material|type|stone|stones|finish|plating)\b\s*:/.test(t)) target = 'material';
        else if (/^care\s*:/.test(t)) target = 'care';
        else if (/^note\s*:/.test(t)) target = box.dims.length ? 'dims' : (box.material.length ? 'material' : 'details');
        box[target].push(n);
      });
      function fill(k) {
        var item = acc.querySelector('[data-k="' + k + '"]');
        if (!item || !box[k].length) return false;
        var b = item.querySelector('.br-acc__b');
        if (k === 'care') b.innerHTML = '';
        box[k].forEach(function (n) { b.appendChild(n); });
        if (k === 'care') { var p = d.createElement('p'); p.innerHTML = '<a href="/pages/jewellery-care">Jewellery care and material</a>'; b.appendChild(p); }
        item.hidden = false;
        return true;
      }
      fill('material'); fill('dims'); fill('care');
      if (!det.children.length) { var dItem = acc.querySelector('[data-k="details"]'); if (dItem) dItem.hidden = true; }
      var first = acc.querySelector('.br-acc__i:not([hidden])');
      acc.querySelectorAll('.br-acc__i').forEach(function (i) { if (i !== first) i.open = false; });
      if (window.matchMedia('(max-width: 767.98px)').matches && first) first.open = false;
    }
  }

  /* ---------------- 2. CARDS ---------------- */
  function initCards(scope) {
    (scope || d).querySelectorAll('.br-media').forEach(function (m) {
      if (m._br) return; m._br = true;
      var sc = m.querySelector('.br-media__scroll');
      var dots = m.querySelectorAll('.br-media__dots b');
      if (sc && dots.length > 1) {
        var h;
        sc.addEventListener('scroll', function () {
          clearTimeout(h);
          h = setTimeout(function () {
            var i = Math.round(sc.scrollLeft / Math.max(1, sc.clientWidth));
            dots.forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
          }, 50);
        }, { passive: true });
        m.querySelectorAll('.br-media__arrow').forEach(function (a) {
          a.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            var dir = a.classList.contains('br-media__arrow--next') ? 1 : -1;
            sc.scrollBy({ left: dir * sc.clientWidth, behavior: 'smooth' });
          });
        });
      }
    });
  }

  function polishOf(btn) {
    var card = btn.closest('.card, .br-best__card');
    if (!card) return 'silver';
    if (card.hasAttribute('data-polish')) return card.getAttribute('data-polish');
    var cb = card.querySelector('input.varient-col');
    return cb && cb.checked ? 'gold' : 'silver';
  }

  function openPicker(handle, btn, polish) {
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var sheet = d.getElementById('br-pick');
      if (!sheet) {
        sheet = d.createElement('div'); sheet.id = 'br-pick';
        sheet.innerHTML = '<div class="br-pick__bg"></div><div class="br-pick__box" role="dialog" aria-modal="true"><button type="button" class="br-pick__x" aria-label="Close">&times;</button><p class="br-pick__name"></p><p class="br-pick__price"></p><div class="br-pick__opts"></div><button type="button" class="br-pick__add">Add to cart</button></div>';
        d.body.appendChild(sheet);
        sheet.querySelector('.br-pick__bg').addEventListener('click', function () { sheet.classList.remove('is-on'); });
        sheet.querySelector('.br-pick__x').addEventListener('click', function () { sheet.classList.remove('is-on'); });
      }
      var chosen = [];
      var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      chosen = first.options.slice();
      p.options.forEach(function (o, i) {
        var vals = o.values.map(function (x) { return x.toLowerCase(); });
        var isPolish = vals.length === 2 && vals.join('|').indexOf('silver') > -1 && vals.join('|').indexOf('gold') > -1;
        if (isPolish) { o.values.forEach(function (x) { if (x.toLowerCase().indexOf(polish) > -1) chosen[i] = x; }); }
      });
      var optBox = sheet.querySelector('.br-pick__opts'); optBox.innerHTML = '';
      function match() { return p.variants.filter(function (v) { return v.options.every(function (x, k) { return x === chosen[k]; }); })[0]; }
      function paint() {
        var v = match(); var add = sheet.querySelector('.br-pick__add');
        sheet.querySelector('.br-pick__price').textContent = v ? 'Rs. ' + (v.price / 100).toLocaleString('en-IN') : '';
        add.disabled = !v || !v.available; add.textContent = v && !v.available ? 'Sold out' : 'Add to cart';
        add.classList.remove('is-pressed');
        optBox.querySelectorAll('button[data-i]').forEach(function (b) { b.classList.toggle('is-on', chosen[Number(b.getAttribute('data-i'))] === b.getAttribute('data-value')); });
      }
      p.options.forEach(function (o, i) {
        if (o.values.length < 2) return;
        var g = d.createElement('div'); g.className = 'br-pick__g';
        var l = d.createElement('span'); l.className = 'br-pick__l'; l.textContent = o.name; g.appendChild(l);
        var row = d.createElement('div'); row.className = 'br-chips';
        o.values.forEach(function (val) {
          var b = d.createElement('button'); b.type = 'button'; b.className = 'br-chip'; b.textContent = val;
          b.setAttribute('data-i', i); b.setAttribute('data-value', val);
          b.addEventListener('click', function () { chosen[i] = val; paint(); });
          row.appendChild(b);
        });
        g.appendChild(row); optBox.appendChild(g);
      });
      sheet.querySelector('.br-pick__name').textContent = p.title;
      var add = sheet.querySelector('.br-pick__add');
      add.onclick = function () { var v = match(); if (v && v.available) addVariant(v.id, add).then(function () { setTimeout(function () { sheet.classList.remove('is-on'); }, 700); }); };
      paint();
      sheet.classList.add('is-on');
      if (btn) btn.classList.remove('is-pressed');
    }).catch(function () { window.location.href = '/products/' + handle; });
  }

  d.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.br-qa');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var polish = polishOf(btn);
    if (btn.getAttribute('data-simple') === '1') {
      var id = (polish === 'gold' ? btn.getAttribute('data-gold') : btn.getAttribute('data-silver')) || btn.getAttribute('data-first');
      if (id) { addVariant(id, btn); return; }
    }
    btn.classList.add('is-pressed');
    openPicker(btn.getAttribute('data-handle'), btn, polish);
  }, true);


  /* ---------------- 3. WISHLIST (saved in this browser) ----------------
     The Swym / Wishlist Hero apps are not running on the store, so the hearts keep their own list
     in localStorage and /pages/swym-wishlist shows it whenever the Swym container stays empty. */
  var WKEY = 'brWishlist';
  function wlGet() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function wlSet(a) { try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {} }
  function wlPaint() {
    var a = wlGet();
    d.querySelectorAll('.br-wish[data-handle]').forEach(function (b) {
      var on = a.indexOf(b.getAttribute('data-handle')) > -1;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.br-wish[data-handle]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-handle'), a = wlGet(), i = a.indexOf(h);
    if (i > -1) { a.splice(i, 1); toast('Removed from wishlist'); } else { a.push(h); toast('Saved to wishlist'); }
    wlSet(a); wlPaint();
  }, true);
  function wlPage() {
    var box = d.getElementById('swym-wishlist-render-container');
    if (!box) return;
    setTimeout(function () {
      if (box.children.length || window._swat) return;
      var a = wlGet();
      box.classList.add('br-wl');
      if (!a.length) { box.innerHTML = '<p class="br-wl__empty">Your wishlist is empty. Tap the heart on any piece to save it here.</p>'; return; }
      box.innerHTML = '';
      a.forEach(function (h) {
        fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
          if (!p) return;
          var el = d.createElement('div'); el.className = 'br-wl__item';
          var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
          el.innerHTML = '<a href="/products/' + p.handle + '" class="br-media br-wl__img"><img alt="" loading="lazy"></a><div class="br-wl__name"></div><div class="br-wl__row"><span class="br-wl__price"></span><button type="button" class="br-wish is-on" data-handle="' + p.handle + '" aria-label="Remove from wishlist"></button></div>';
          if (img) el.querySelector('img').src = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=600';
          el.querySelector('.br-wl__name').textContent = p.title;
          el.querySelector('.br-wl__price').textContent = 'Rs. ' + (p.price / 100).toLocaleString('en-IN');
          box.appendChild(el); wlPaint();
        });
      });
    }, 2500);
  }

  /* phone product page: lift the floating app buttons above the buying sheet */
  function liftFloats() {
    if (!d.getElementById('br-pdp') || !window.matchMedia('(max-width: 767.98px)').matches) return;
    [['shopify-chat', '.activator-nudge{ transform:translateY(-236px) !important }'], ['gty-whatsapp-chat-button', '.gty-wacb-wrapper{ bottom:272px !important }']].forEach(function (cfg) {
      var tries = 0;
      (function attempt() {
        var host = d.querySelector(cfg[0]);
        if (host && host.shadowRoot) {
          if (!host.shadowRoot.getElementById('br-bw-lift')) { var s = d.createElement('style'); s.id = 'br-bw-lift'; s.textContent = cfg[1]; host.shadowRoot.appendChild(s); }
          return;
        }
        if (++tries < 40) setTimeout(attempt, 250);
      })();
    });
  }

  function boot() { initPdp(); initCards(); wlPaint(); wlPage(); liftFloats(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  window.BRBW = { initCards: initCards };
})();
